import uuid from 'uuid/v1'

const { ipcRenderer } = window

export const getCookie = cname => {
  if (typeof document === 'undefined') return ''

  const nameEQ = `${cname}=`
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length)
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length) || ''
    }
  }
  return ''
}

export const setCookie = (name, value, days = 365) => {
  const date = new Date()
  let expires
  if (days) {
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toGMTString()}`
  } else {
    expires = ''
  }
  document.cookie = `${name}=${value}${expires}; path=/`
}

export const saveAddress = newAddress => {
  let user = window.sessionStorage.getItem('user')
  user = (user && JSON.parse(user)) || {}
  user.address = newAddress
  window.sessionStorage.setItem('user', JSON.stringify(user))
}

export const getUuid = () => {
  let userId = window.localStorage.getItem('userId')
  if (!userId) {
    userId = uuid()
    window.localStorage.setItem('userId', userId)
  }

  return userId
}

export const saveFingerPrint = data => {
  window.localStorage.setItem('__DI__', JSON.stringify(data))
}

export const saveKeystoreToNative = keystore => {
  ipcRenderer.send('keystore_save', keystore)
  return new Promise((resolve, reject) => {
    ipcRenderer.on('save_keystore_success', (event, args) => {
      resolve(args)
    })

    ipcRenderer.on('save_keystore_fail', (event, args) => {
      reject(args)
    })
  })
}

export const getNativeKeystore = () => {
  ipcRenderer.send('keystore_read')
  return new Promise((resolve, reject) => {
    ipcRenderer.on('keystore_read_success', (event, args) => {
      resolve(args)
    })

    ipcRenderer.on('keystore_read_failure', () => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('read keystores failed')
    })
  })
}

// chrome storage
export default (data, callback) => {
  if (window.chrome && window.chrome.storage) {
    window.chrome.storage.local.set({ user: data }, () => {
      callback && callback(data)
    })
  }
}
